export default {
  methods: {
    conversionLNG(val = 0, isOmit,fixed = 2) {
      const value = Number(val)
      const radio = 1400;
      const omit = isOmit ? 10000 : 1;
      return Number((value * radio / omit).toFixed(fixed));
    },
    conversionCNG(val, isOmit,fixed = 2) {
      const radio = 1400;
      const omit = isOmit ? 10000 : 1;
      return Number((val * radio / omit).toFixed(fixed));
    }
  }
};
